// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BaseTeamButton_wrapper_21VlG","isActive":"BaseTeamButton_isActive_3iw3j"};